import React, { Component } from "react";

export class TableTH extends Component {
  render() {
    return (
      <th
        draggable="false"
        className="is-sortable is-unselectable is-current-sort"
      >
        <div className="th-wrap has-text-centered">
          <span className="is-relative">{this.props.text}</span>
        </div>
      </th>
    );
  }
}

export class InputAgregate extends Component {
  render() {
    return (
      <div className="inputAgregate">
        <div className="control   is-clearfix">
          <div className="field has-addons">
            <p className="control is-full has-icons-leftx has-icons-right">
              <input
                type="text"
                placeholder={ this.props.placeholder ?? '' }
                id={ this.props.id ?? false }
                name={ this.props.name ?? false }
                defaultValue={ this.props.value ?? '' }
                required="required"
                className="input"
                maxLength="300"
                // onChange={ this.props.onChange ?? false }
              />
              {/* <span className="icon is-left">
              <span>1</span>
            </span> */}
            </p>
            <div className="control">
              <button onClick={ e => this.props.onClick(e, this.props.id) ?? false } type="button" className="button is-info">
                <i className={`fas fa-${this.props.btnAdd && this.props?.btnAdd ? 'plus' : 'trash'}`}></i>
              </button>
            </div>
          </div>
        </div>
        <p className="help">0 / 300 </p>
      </div>
    );
  }
}
